import { render, staticRenderFns } from "./select-role-modal.vue?vue&type=template&id=6a7aadaa&scoped=true&"
import script from "./select-role-modal.vue?vue&type=script&lang=ts&"
export * from "./select-role-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7aadaa",
  null
  
)

export default component.exports